/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Token_Icon_Market_Cap_LabelInputs */

const en_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market cap`)
};

const de_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktkapitalisierung`)
};

const pt_br2_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitalização de mercado`)
};

const tr_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piyasa değeri`)
};

const zh_cn2_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市值`)
};

const zh_hk2_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市值`)
};

const ko_kr2_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시가총액`)
};

const ru_ru2_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рыночная капитализация`)
};

const es_419_components_token_icon_market_cap_label = /** @type {(inputs: Components_Token_Icon_Market_Cap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitalización de mercado`)
};

/**
* | output |
* | --- |
* | "Market cap" |
*
* @param {Components_Token_Icon_Market_Cap_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_market_cap_label = /** @type {((inputs?: Components_Token_Icon_Market_Cap_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_Market_Cap_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_market_cap_label(inputs)
	if (locale === "de") return de_components_token_icon_market_cap_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_market_cap_label(inputs)
	if (locale === "tr") return tr_components_token_icon_market_cap_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_market_cap_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_market_cap_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_market_cap_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_market_cap_label(inputs)
	return es_419_components_token_icon_market_cap_label(inputs)
});